import React from "react"
import { css } from "@emotion/core"

class CommentForm extends React.Component {
  constructor(props) {
    super(props)

    this.handleSubmit = this.handleSubmit.bind(this)
  }

  async handleSubmit(e) {
    e.preventDefault()

    let formStatusElem = document.getElementById("comment-form-status")

    let formData = new FormData(document.getElementById("comment_submit_form"))

    formStatusElem.classList.remove(...formStatusElem.classList)
    formStatusElem.classList.add("pending")

    // overall structure from https://stackoverflow.com/a/54292559

    // convert FormData to json object
    // SOURCE: https://stackoverflow.com/a/46774073
    const json = {}
    formData.forEach(function(value, prop) {
      json[prop] = value
    })

    // convert json to urlencoded query string
    // SOURCE: https://stackoverflow.com/a/37562814 (comments)
    const formBody = Object.keys(json)
      .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(json[key]))
      .join("&")

    const response = await fetch(
      "https://satchel-staticman.herokuapp.com/v2/entry/awchen/saaswrapper-comments/master/comments",
      {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formBody,
      }
    )
      .then(response => {
        formStatusElem.classList.remove(...formStatusElem.classList)
        formStatusElem.classList.add("success")
      })
      .catch(error => {
        console.log(error)
        formStatusElem.classList.remove(...formStatusElem.classList)
        formStatusElem.classList.add("failure")
      })
  }

  render() {
    return (
      <form
        id="comment_submit_form"
        onSubmit={this.handleSubmit}
        css={css`
          margin-bottom: 60px;
        `}
      >
        <h2 id="comments">Add a comment</h2>
        <input name="fields[slug]" type="hidden" value={this.props.slug} />

        <div
          css={css`
            margin-bottom: 20px;
          `}
        >
          <div
            css={css`
              display: flex;
              align-items: center;
              margin-bottom: 5px;
            `}
          >
            <label for="form-comment">Comment</label>
            <div
              css={css`
                margin-left: 5px;
                display: block;
                font-weight: 600;
                font-size: 13px;
                color: #473dc7;
                background-color: #e0ddf6;
                padding: 1px 5px;
                border-radius: 3px;
              `}
            >
              Required
            </div>
          </div>
          <textarea
            name="fields[message]"
            id="form-comment"
            placeholder="Join the discussion"
            required
            css={css`
              display: block;
              width: 100%;
              min-width: 100%;
              max-width: 100%;
              min-height: 100px;
              max-height: 800px;
              padding: 8px 12px;

              border-radius: 3px;
              box-shadow: 0px 2px 1px rgba(0, 0, 0, 0.05);
              background-color: #fff;
              border: 1px solid #aaa;
            `}
          />
        </div>

        <div
          css={css`
            max-width: 300px;
            margin-bottom: 20px;
          `}
        >
          <div
            css={css`
              display: flex;
              align-items: center;
              margin-bottom: 5px;
            `}
          >
            <label for="form-name">Name</label>
            <div
              css={css`
                margin-left: 5px;
                display: block;
                font-weight: 600;
                font-size: 13px;
                color: #473dc7;
                background-color: #e0ddf6;
                padding: 1px 5px;
                border-radius: 3px;
              `}
            >
              Required
            </div>
          </div>
          <input
            name="fields[name]"
            id="form-name"
            type="text"
            placeholder="Name"
            required
            css={css`
              display: block;
              width: 100%;
              padding: 8px 12px;

              border-radius: 3px;
              box-shadow: 0px 2px 1px rgba(0, 0, 0, 0.05);
              background-color: #fff;
              border: 1px solid #aaa;
            `}
          />
        </div>

        <div
          css={css`
            max-width: 300px;
            margin-bottom: 20px;
          `}
        >
          <div
            css={css`
              display: flex;
              align-items: center;
              margin-bottom: 5px;
            `}
          >
            <label for="form-email">Email</label>
            <div
              css={css`
                margin-left: 5px;
                display: block;
                font-weight: 600;
                font-size: 13px;
                color: #555;
                background-color: #fff;
                border: 1px solid #ccc;
                padding: 1px 5px;
                border-radius: 3px;
              `}
            >
              Optional
            </div>
          </div>
          <input
            name="fields[email]"
            id="form-email"
            type="email"
            placeholder="Email"
            css={css`
              display: block;
              width: 100%;
              padding: 8px 12px;

              border-radius: 3px;
              box-shadow: 0px 2px 1px rgba(0, 0, 0, 0.05);
              background-color: #fff;
              border: 1px solid #aaa;
            `}
          />
          <div
            css={css`
              margin-top: 8px;
              color: #888;
              font-size: 12px;
              line-height: 14px;
            `}
          >
            Your email is only used to send notifications on replies to your
            comment.
          </div>
        </div>

        <div id="comment-form-status"></div>

        <button
          type="submit"
          css={css`
            outline: none;
            background-color: #fff;
            padding: 8px 12px;
            color: #473dc7;
            font-weight: 500;
            border: 1px solid #473dc7;
            border-radius: 3px;
            box-shadow: 0px 2px 1px rgba(0, 0, 0, 0.05);

            -webkit-transition: color, background-color 0.08s ease-in-out;
            transition: color, background-color 0.08s ease-in-out;

            :hover {
              background-color: #e0ddf6;
            }

            :active {
              background-color: #473dc7;
              color: #fff;
            }
          `}
        >
          Submit Comment
        </button>
      </form>
    )
  }
}

export default CommentForm
